import httpService from "../utils/httpService";

export const authorizeAsync = async (code) => {
    const response = await httpService.post('/authorize', { code });
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };

  export const resendAuthorizationCodeAsync = async () => {
    const response = await httpService.post('/authorize/code/resend');
    const resObj = response.data;
    if (!resObj.succeeded) {
      throw new Error(resObj.errors[0]);
    }
    return resObj.result;
  };